import React, { Component, useState } from "react";
import { render } from "react-dom";
import AdminJury from "./AdminJuryMobile";
import AdminJuryD from "./AdminJuryDesktop";
import { useMediaQuery } from 'react-responsive'


export default function AdminHomeResponsive(props){
    const isMobileDevice = useMediaQuery({
        query: "(max-width: 48em)",
      });
      console.log("ROOO",props.juryType)
  return(
      <div>
        {!isMobileDevice && <AdminJuryD juryType = {props.juryType}/>}
        {isMobileDevice && <AdminJury juryType = {props.juryType}/>}  
      </div>
    )
}

